import React, { useEffect, useReducer } from "react";
import { useParams } from "react-router-dom";
import rpsReducer from "../../reducers/rps";
import * as action from "../../actions/rps";
//import { SketchField, Tools } from 'react-sketch';
const stateInit = { spsWbInfo: null };
export default (props) => {
  const { id, tab } = useParams();
  const [state, dispatch] = useReducer(rpsReducer, stateInit);
  let { spsWbInfo } = state;
  useEffect(() => {
    action.fetchSPSWB(dispatch, `${id}&type=${tab}`);
  }, [id, tab]);
  const getWBData = () => {
    let wbData = [];
    if (spsWbInfo) {
      if (typeof spsWbInfo == "string") wbData = JSON.parse(spsWbInfo);
      if (typeof spsWbInfo == "object") wbData = spsWbInfo;
    }
    return wbData;
  };
  return (
    <div className="view-wb-sps">
      <div className="wb-container">
        <div style={{ background: "#fff" }}>
          {/* <SketchField value={getWBData()} tool="pan" /> */}
        </div>
      </div>
    </div>
  );
};
